import { refreshPush } from './push';

/** Web app: browsers only show the notification prompt after a tap (push.ts handles it); no location prompt up front. */
export async function askLaunchPermissions(_isDriver: boolean): Promise<void> {
  await refreshPush();
}
